import { Col, InputNumber, Row, Table } from "antd";
import React from "react";
import { Link } from "react-router-dom";

/** Line net = qty × unit × (1 − discount%/100) — matches purchase invoice / PDF. */
function lineNetTotal(record, qty) {
	const unit = Number(
		record.product_sale_price ?? record.product_purchase_price ?? 0
	);
	const q = Number(qty) || 0;
	const pct =
		Number(
			record.product_purchase_discount ?? record.product_discount ?? 0
		) || 0;
	const gross = unit * q;
	return gross * (1 - Math.min(100, Math.max(0, pct)) / 100);
}

const PurchaseProductListCard = ({ list, updateReturn, returnOnChange }) => {
	const columns = [
		{
			title: "ID",
			dataIndex: "product_id",
			key: "product_id",
		},
		{
			title: "Name",
			dataIndex: "product",
			key: "product.name",
			render: (product) => (
				<Link to={`/product/${product.id}`}>{product.name}</Link>
			),
		},
		{
			title: "Product Quantity",
			dataIndex: "product_quantity",
			key: "product_quantity",
		},
		{
			title: "List (MRP)",
			key: "product_sale_price",
			render: (_, record) =>
				record.product_sale_price ?? record.product_purchase_price ?? "—",
		},
		{
			title: "Product Discount (%)",
			dataIndex: "product_purchase_discount",
			key: "product_purchase_discount",
			render: (value, record) => {
				const pct = value ?? record.product_discount ?? 0;
				return pct;
			},
		},
		{
			title: "Total Price ",
			key: "Total Price ",
			dataIndex: "",
			render: (_, record) => {
				const qty = record.return_quantity
					? Number(record.remain_quantity) || 0
					: Number(record.product_quantity) || 0;
				return lineNetTotal(record, qty).toFixed(2);
			},
		},
	];

	if (updateReturn) {
		columns.splice(4, 0, {
			title: "Return Quantity",
			dataIndex: "return_quantity",
			key: "return_quantity",
			width: "150px",
			render: (
				value,
				{ product_id, product_quantity, product_purchase_price: price }
			) => {
				return (
					<div>
						<InputNumber
							onChange={(value) =>
								returnOnChange({ id: product_id, value, price })
							}
							style={{ width: "120px" }}
							placeholder='Return Qty'
							max={product_quantity}
							min={0}
							value={value}
						/>
					</div>
				);
			},
		});
	}

	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

	return (
		<Row>
			<Col span={24} className='mt-2'>
				<div
					className='header-solid h-full m-2'
					bordered={false}
					bodyStyle={{ paddingTop: "0" }}>
					<h6 className='font-semibold m-0 text-center'>
						Purchased Product Information
					</h6>
					<hr />
					<div className='col-info'>
						<Table
							scroll={{ x: true }}
							loading={!list}
							columns={columns}
							dataSource={list ? addKeys(list) : []}
						/>
					</div>
				</div>
			</Col>
		</Row>
	);
};

export default PurchaseProductListCard;
